import * as React from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components/macro'
import UnforgettablePhotos from 'assets/images/HomeImages/Unforgettable.jpg'
import {QUERIES} from 'common/constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px 16px;
  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    padding: 96px 128px;
    gap: 80px;
  }
  justify-content: space-between;
  align-items: center;
  gap: 64px;
  width: 100%;
  background-color: var(--darker-grey);
  font-family: 'Mulish';
`

const LeftSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const RightSection = styled.div`
  width: 100%;
`

const LeftSectionText = styled.div`
  text-align: center;
  @media ${QUERIES.tabletAndUp} {
    text-align: inherit;
  }
`

const Title = styled.div`
  color: white;
  font-size: calc(24 / 16 * 1rem);
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(40 / 16 * 1rem);
    font-style: italic;
  }
  line-height: 1.1;
  margin-bottom: 24px;
  padding-right: 20px;
`

const Message = styled.div`
  color: white;
  font-size: calc(16 / 16 * 1rem);
  text-align: center;
  line-height: 20px;
  /* padding: 0 16px; */
  @media ${QUERIES.tabletAndUp} {
    line-height: 35px;
    text-align: inherit;
    font-size: calc(28 / 16 * 1rem);
  }
  margin-bottom: 24px;
`

const LearnMore = styled(Link)`
  color: white;
  font-size: calc(16 / 16 * 1rem);
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(24 / 16 * 1rem);
  }
`

const UnforgettableSection = () => {
  return (
    <Container>
      <LeftSection>
        <LeftSectionText>
          <Title>Specializing in high-quality golf experiences</Title>
          <Message>
            With over 60 years of golf event experience, our team is prepared to
            exceed your event goals with confidence.
          </Message>
          <LearnMore to="/about">Learn More</LearnMore>
        </LeftSectionText>
      </LeftSection>
      <RightSection>
        <img src={UnforgettablePhotos} />
      </RightSection>
    </Container>
  )
}
export default UnforgettableSection
